let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gw2um")).then(() => parcelRequire('hkrvJ'));